// src/storageLocation/service/RentContractDocumentService.ts

import axios from 'axios';
import {RentContractDocument} from "../models/RentContractDocument";
import {getToken} from "../auth/service/authService";
import {BackendUrl} from "../util/config";

const API_BASE = BackendUrl + '/rent-contracts';

export const uploadDocument = async (rentContractId: number, file: File): Promise<RentContractDocument[]> => {
    const formData = new FormData();
    formData.append('file', file)

    const response = await axios.post<RentContractDocument[]>(`${API_BASE}/${rentContractId}/documents/upload`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: "Bearer " + getToken()
        },
    });

    return response.data;
};

export const getDocuments = async (rentContractId: number): Promise<RentContractDocument[]> => {
    const response = await axios.get<RentContractDocument[]>(`${API_BASE}/${rentContractId}/documents`);
    return response.data;
};

export const downloadDocument = async (rentContractId: number, documentId: number): Promise<Blob> => {
    const response = await axios.get(`${API_BASE}/${rentContractId}/documents/${documentId}/download`, {
        headers: {
            Authorization: "Bearer " + getToken()
        },
        responseType: 'blob',
    });
    return response.data;
};

export const deleteDocument = async (rentContractId: number, documentId: number): Promise<void> => {
    await axios.delete(`${API_BASE}/${rentContractId}/documents/${documentId}`);
};
